export type CallDuration = 30 | 60;

export const BOOKING_OPTIONS: Record<CallDuration, { label: string }> = {
  30: { label: "30-minute call" },
  60: { label: "60-minute call" },
};

export type ScheduleAccess = {
  expiresAt: string;
  bookings: Record<CallDuration, { url: string; embedUrl: string }>;
};

export function callDurationFromQuery(value: string | null): CallDuration {
  return value === "60" ? 60 : 30;
}
